import { render, staticRenderFns } from "./wrongCard.vue?vue&type=template&id=6b564c9c&scoped=true&"
import script from "./wrongCard.vue?vue&type=script&lang=js&"
export * from "./wrongCard.vue?vue&type=script&lang=js&"
import style0 from "./wrongCard.vue?vue&type=style&index=0&id=6b564c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b564c9c",
  null
  
)

export default component.exports